import { useNavigate } from "react-router-dom";

const Road = ({ title, upgradeToPro, keyTitle, company }) => {

    const navigate = useNavigate();
    let titleImage = null;
    keyTitle === "Pro" ? titleImage = require(`../../../../images/whatYouGetModal/Pro.png`) :
        keyTitle === "Lite" ? titleImage = require(`../../../../images/whatYouGetModal/Lite.png`) :
            titleImage = null;
    return (
        <>
            <div className={`w100 df aic pr`}>
                {keyTitle && <div className="df fdc aic jcc w10" style={{ height: '153px' }}>
                    <div className={`bg76 c1 br20px fs1-75rem ttu df aic jcc w100 fw600`} style={{ padding: '0px 32px' }}>
                        {keyTitle}
                    </div>
                    {/* {titleImage && <img className="mt2rem" src={titleImage} alt="keyTitle" />} */}
                </div>
                }
                <div
                    className={`pr road ${keyTitle ? 'dib' : ''}`}
                    style={{ width: keyTitle ? keyTitle === "Lite" ? '80%' : keyTitle === "Pro" ? '82%' : keyTitle === "Free" ? '60%' : '87%' : '100%' }}
                >
                    {title && <span className='c1 br20px fs1rem bg76 pa zi1 df aic jcc' style={{ left: '2px', top: '2px', paddingLeft: '1rem', paddingRight: '1rem', height: '32px' }}>{title}</span>}
                    <span className='db' style={{ width: '100%', borderTop: '3px solid transparent', borderImage: 'repeating-linear-gradient( to right, white 0, white 10px,  transparent 10px, transparent 20px ) 1' }}></span>

                    {upgradeToPro && <span onClick={() => navigate(`/billing/${company['_id']}`)} className='c1 br20px fs1rem bg4 pa zi1 df aic jcc cp' style={{ right: '-4px', top: '-4px', paddingLeft: '1rem', paddingRight: '1rem', height: '44px' }}>Upgrade for more</span>}
                </div>
            </div>
        </>
    )
}

export default Road